import axios from "axios";

const PROD_URL = "https://d4r005-sisp.hf.space";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || (window.location.hostname === "localhost" && !window.location.port ? PROD_URL : "");
export const API = BACKEND_URL
  ? (BACKEND_URL.endsWith("/") ? `${BACKEND_URL}api` : `${BACKEND_URL}/api`)
  : "/api";

const api = axios.create({
  baseURL: API.endsWith("/") ? API : `${API}/`,
});

api.interceptors.request.use((config) => {
  // Asegurar que las rutas relativas no ignoren el baseURL debido al slash inicial
  if (config.url && config.url.startsWith("/") && !config.url.startsWith("http")) {
    config.url = config.url.substring(1);
  }
  const token = localStorage.getItem("sisp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("sisp_token")) {
      localStorage.removeItem("sisp_token");
      if (!window.location.pathname.includes("/login")) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function apiError(err, fallback = "Ocurrió un error. Inténtalo de nuevo.") {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}

export default api;
